module.exports = __webpack_public_path__ + "static/img_4851-f2b583a9f514d81f2667a273be01a0e5.webp";